import { render, staticRenderFns } from "./ManufacturerCreateUpdate.vue?vue&type=template&id=d96e2d1a&"
import script from "./ManufacturerCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ManufacturerCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports